var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"HeroContainer",style:({
      'font-size': _vm.fontSize,
      'margin-left': _vm.marginLeft,
      width: '100%',
      'margin-top': _vm.marginTop,
    })},[_c('div',{staticClass:"HeroContent"},[_c('div',{staticClass:"HeroText",style:({
          width: _vm.width,
          marginRight: _vm.heroMargin,
        })},[_c('p',{staticClass:"font-weight-bold",style:({
            fontSize: _vm.fontSizeTitleHero,
          })},[_vm._v(" Sukseskan Proyek Tanpa "),_c('span',{staticClass:"red--text"},[_vm._v("Khawatir Pembiayaan!")])]),_c('p',{staticClass:"font-weight-normal",style:({
            'font-size': _vm.fontSizeSub,
            'font-family': 'Inter',
            'font-weight': 600,
            width: _vm.widthDesc,
            'line-height': _vm.lineHeight,
          })},[_vm._v(" Pinjaman fleksibel tanpa agunan bagi pemilik usaha. Bunga kompetitif, mulai dari 10% per tahun dan tenor hingga 12 bulan! ")])]),_c('div',{staticClass:"Shape",style:({
          width: _vm.widthForm,
          marginTop: _vm.shapeMargin,
          padding: _vm.paddingShape,
        })},[_c('p',{staticClass:"title-1",style:({
            'font-family': 'Sora',
            'font-size': _vm.fontSizeForm,
          })},[_vm._v(" Daftar Pinjaman Sekarang! ")]),_c('p',{staticClass:"desc",style:({
            'font-family': 'Inter',
            'font-size': _vm.fontSizeDescription,
          })},[_vm._v(" Isi formulir di bawah dengan benar untuk mendapatkan pinjaman! ")]),_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('div',{staticClass:"Name-Input"},[_c('p',{staticClass:"Name-Title",style:({
                'font-family': 'Inter',
                'font-size': _vm.fontSizeDescr,
                'margin-bottom': _vm.marginName,
              })},[_vm._v(" Nama Lengkap ")]),_c('v-text-field',{staticClass:"input-field",style:({
                'font-family': 'Inter',
                'font-size': _vm.fontSizeDescr,
              }),attrs:{"color":"#D3352C","rules":_vm.reqRules,"placeholder":"Nama Anda"},model:{value:(_vm.form.full_name),callback:function ($$v) {_vm.$set(_vm.form, "full_name", $$v)},expression:"form.full_name"}})],1),_c('div',{staticClass:"Name-Input"},[_c('p',{staticClass:"Name-Title",style:({
                'font-family': 'Inter',
                'font-size': _vm.fontSizeDescr,
                'margin-bottom': _vm.marginName,
                'margin-top': _vm.marginTopName,
              })},[_vm._v(" Alamat Email ")]),_c('v-text-field',{staticClass:"input-field",style:({
                'font-family': 'Inter',
                'font-size': _vm.fontSizeDescr,
              }),attrs:{"color":"#D3352C","rules":_vm.emailRules,"placeholder":"Email Anda"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_c('div',{staticClass:"Name-Input"},[_c('p',{staticClass:"Name-Title",style:({
                'font-family': 'Inter',
                'font-size': _vm.fontSizeDescr,
                'margin-bottom': _vm.marginName,
                'margin-top': _vm.marginTopName,
              })},[_vm._v(" No Telepon ")]),_c('v-text-field',{staticClass:"input-field",style:({
                'font-family': 'Inter',
                'font-size': _vm.fontSizeDescr,
              }),attrs:{"color":"#D3352C","type":"number","rules":_vm.phoneRules,"prefix":"(+62)","placeholder":"No Telepon Anda"},model:{value:(_vm.form.phone_number),callback:function ($$v) {_vm.$set(_vm.form, "phone_number", $$v)},expression:"form.phone_number"}})],1),_c('div',{staticClass:"Name-Input"},[_c('p',{staticClass:"Name-Title",style:({
                'font-family': 'Inter',
                'font-size': _vm.fontSizeDescr,
                'margin-bottom': _vm.marginName,
                'margin-top': _vm.marginTopName,
              })},[_vm._v(" Nama Perusahaan ")]),_c('v-text-field',{staticClass:"input-field",style:({
                'font-family': 'Inter',
                'font-size': _vm.fontSizeDescr,
              }),attrs:{"color":"#D3352C","rules":_vm.reqRules,"placeholder":"Nama Perusahaan"},model:{value:(_vm.form.company),callback:function ($$v) {_vm.$set(_vm.form, "company", $$v)},expression:"form.company"}})],1),_c('div',{staticClass:"Name-Input"},[_c('p',{staticClass:"Name-Title",style:({
                'font-family': 'Inter',
                'font-size': _vm.fontSizeDescr,
                'margin-bottom': _vm.marginName,
                'margin-top': _vm.marginTopName,
              })},[_vm._v(" Bidang Perusahaan ")]),_c('v-select',{style:({
                'font-family': 'Inter',
                'font-size': _vm.fontSizeDescr,
              }),attrs:{"items":_vm.jobTypeOptions,"item-text":"name","item-value":"code","label":"Bidang Perusahaan","persistent-hint":"","single-line":"","dense":"","color":"#D3352C"},model:{value:(_vm.form.job_type),callback:function ($$v) {_vm.$set(_vm.form, "job_type", $$v)},expression:"form.job_type"}}),(_vm.jobErr)?_c('div',{staticClass:"mt-n3 red--text",style:({
                'font-family': 'Inter',
                'font-size': _vm.fontSizeDescr,
              })},[_vm._v(" required ")]):_vm._e()],1),_c('div',{staticClass:"Name-Input"},[_c('p',{staticClass:"Name-Title",style:({
                'font-family': 'Inter',
                'font-size': _vm.fontSizeDescr,
                'margin-bottom': _vm.marginName,
                'margin-top': _vm.marginTopName,
              })},[_vm._v(" Jumlah Pinjaman ")]),_c('vuetify-money',{staticClass:"input-field",style:({
                'font-family': 'Inter',
                'font-size': _vm.fontSizeDescr,
              }),attrs:{"color":"#D3352C","rules":_vm.amountRules,"options":_vm.options,"placeholder":"Jumlah Pinjaman Anda"},model:{value:(_vm.form.amount),callback:function ($$v) {_vm.$set(_vm.form, "amount", $$v)},expression:"form.amount"}})],1)]),_c('v-btn',{staticClass:"Shape-Button-Text text-none",attrs:{"color":"#D3352C","rounded":"","block":"","dark":""},on:{"click":function($event){return _vm.submit()}}},[_c('p',{staticStyle:{"margin":"0px"}},[_vm._v("Kirim Pendaftaran")])])],1)])]),_c('img',{staticClass:"Hero",attrs:{"src":require("../assets/lpse/Hero.jpg")}}),_c('div',{staticClass:"d-flex align-center justify-center mt-n1 py-4",staticStyle:{"background-color":"#310A0A"}},[_c('div',[_c('img',{staticClass:"point",style:({
          width: _vm.widthPoint,
        }),attrs:{"src":require("../assets/lpse/Pinjaman-Tersalurkan.svg")}}),_c('img',{staticClass:"point",style:({
          width: _vm.widthPoint,
        }),attrs:{"src":require("../assets/lpse/Pinjaman-Lunas.svg")}}),_c('img',{staticClass:"point",style:({
          width: _vm.widthPoint,
        }),attrs:{"src":require("../assets/lpse/Total-Outstanding.svg")}}),_c('img',{staticClass:"point",style:({
          width: _vm.widthPoint,
        }),attrs:{"src":require("../assets/lpse/Total-Peminjam.svg")}})])]),_c('div',{staticClass:"why-container",staticStyle:{"background-color":"#FFFFFF"}},[_c('div',{staticClass:"why-1"},[_c('div',{staticClass:"why-text",style:({
          'font-family': 'Sora',
          fontSize: _vm.fontSizeWhy,
          width: _vm.widthBg,
          height: _vm.heightBgRedWhy,
          padding: _vm.paddingShapeWhy,
        })},[_vm._v(" Kenapa Memilih Dompet Kilat? ")])]),_c('div',{staticClass:"why-2",style:({
        marginRight: _vm.marginWhy,
      })},[_c('img',{style:({
          width: _vm.widthWhyPicture,
        }),attrs:{"src":require("../assets/lpse/Contents.jpg")}})])]),_c('div',{staticClass:"d-flex flex-column align-center justify-center py-12",staticStyle:{"background-color":"#FFFFFF"}},[_c('h1',{staticClass:"titleText",style:({
        fontSize: _vm.fontSize,
      })},[_vm._v(" Apa yang Harus Dilakukan? ")]),_c('div',{staticClass:"what-container"},[_c('div',{staticClass:"card1",style:({
          width: _vm.widthCard,
          height: _vm.heightCard,
        })},[_c('p',{staticClass:"peminjam",style:({
            fontSize: _vm.fontSizePeminjam,
            'font-family': 'Sora',
          })},[_vm._v(" Dilakukan Oleh Peminjam ")]),_c('div',{staticClass:"card-point1"},[_c('div',{staticClass:"circle-point",style:({
              width: _vm.widthCircle,
              height: _vm.heightCircle,
            })},[_c('div',{staticClass:"one",style:({
                fontSize: _vm.fontSizeInside,
              })},[_vm._v(" 01 ")])]),_c('div',{staticClass:"point-1",style:({
              width: _vm.widthPointHow,
            })},[_c('div',{staticClass:"imgCircle",style:({
                width: _vm.widthBgCircle,
                height: _vm.widthBgCircle,
                'min-width': _vm.minWidthBgCircle,
              })},[_c('img',{staticClass:"imgIcon",style:({
                  width: _vm.widthIcon,
                }),attrs:{"src":require("../assets/pengajuan/Web.svg"),"alt":""}})]),_c('div',{staticClass:"text-point",style:({
                'font-family': 'Inter',
                fontSize: _vm.fontSizeInside,
              })},[_vm._v(" Perusahaan pemenang tender proyek pemerintah mengajukan pinjaman di website Dompet Kilat ")])])]),_c('div',{staticClass:"card-point1",style:({
            marginTop: _vm.marginCard,
          })},[_c('div',{staticClass:"circle-point",style:({
              width: _vm.widthCircle,
              height: _vm.heightCircle,
            })},[_c('div',{staticClass:"one",style:({
                fontSize: _vm.fontSizeInside,
              })},[_vm._v(" 02 ")])]),_c('div',{staticClass:"point-1",style:({
              width: _vm.widthPointHow,
            })},[_c('div',{staticClass:"imgCircle",style:({
                width: _vm.widthBgCircle,
                height: _vm.widthBgCircle,
                'min-width': _vm.minWidthBgCircle,
              })},[_c('img',{staticClass:"imgIcon",style:({
                  width: _vm.widthIcon,
                }),attrs:{"src":require("../assets/pengajuan/Upoad.svg"),"alt":""}})]),_c('div',{staticClass:"text-point",style:({
                'font-family': 'Inter',
                fontSize: _vm.fontSizeInside,
              })},[_vm._v(" Peminjam mengunggah dokumen Purchase Order (PO) atau Surat Perintah Kerja (SPK) ")])])]),_c('img',{staticClass:"arrow",style:({
            marginLeft: _vm.marginArrow,
            marginRight: _vm.marginArrowRight,
            marginTop: _vm.marginTopArrow,
          }),attrs:{"src":require("../assets/pengajuan/Arrow.svg"),"alt":""}}),_c('div',{staticClass:"card-point1",style:({
            marginTop: _vm.marginCard07,
          })},[_c('div',{staticClass:"circle-point",style:({
              width: _vm.widthCircle,
              height: _vm.heightCircle,
            })},[_c('div',{staticClass:"one",style:({
                fontSize: _vm.fontSizeInside,
              })},[_vm._v(" 07 ")])]),_c('div',{staticClass:"point-1",style:({
              width: _vm.widthPointHow,
            })},[_c('div',{staticClass:"imgCircle",style:({
                width: _vm.widthBgCircle,
                height: _vm.widthBgCircle,

                'min-width': _vm.minWidthBgCircle,
              })},[_c('img',{staticClass:"imgIcon",style:({
                  width: _vm.widthIcon,
                }),attrs:{"src":require("../assets/pengajuan/Money.svg"),"alt":""}})]),_c('div',{staticClass:"text-point",style:({
                'font-family': 'Inter',
                fontSize: _vm.fontSizeInside,
              })},[_vm._v(" Peminjam melunasi pinjaman dan Dompet Kilat membagikan keuntungan kepada para pendana. ")])])])]),_c('div',{staticClass:"card2",style:({
          width: _vm.widthCard,
          height: _vm.heightCard,
        })},[_c('p',{staticClass:"dompetKilat",style:({
            fontSize: _vm.fontSizePeminjam,
            'font-family': 'Sora',
          })},[_vm._v(" Dilakukan Oleh Dompet Kilat ")]),_c('div',{staticClass:"card-point1",style:({
            marginTop: _vm.marginCard02,
          })},[_c('div',{staticClass:"circle-point1",style:({
              width: _vm.widthCircle,
              height: _vm.heightCircle,
            })},[_c('div',{staticClass:"two",style:({
                fontSize: _vm.fontSizeInside,
              })},[_vm._v(" 03 ")])]),_c('div',{staticClass:"point-1",style:({
              width: _vm.widthPointHow,
            })},[_c('div',{staticClass:"imgCircle",style:({
                width: _vm.widthBgCircle,
                height: _vm.widthBgCircle,
                'min-width': _vm.minWidthBgCircle,
              })},[_c('img',{staticClass:"imgIcon",style:({
                  width: _vm.widthIcon,
                }),attrs:{"src":require("../assets/pengajuan/Checklist.svg"),"alt":""}})]),_c('div',{staticClass:"text-point",style:({
                'font-family': 'Inter',
                fontSize: _vm.fontSizeInside,
              })},[_vm._v(" Dompet Kilat menganalisa seluruh data peminjam dan memberikan skor kredit ")])])]),_c('div',{staticClass:"card-point1",style:({
            marginTop: _vm.marginCard,
          })},[_c('div',{staticClass:"circle-point1",style:({
              width: _vm.widthCircle,
              height: _vm.heightCircle,
            })},[_c('div',{staticClass:"two",style:({
                fontSize: _vm.fontSizeInside,
              })},[_vm._v(" 04 ")])]),_c('div',{staticClass:"point-1",style:({
              width: _vm.widthPointHow,
            })},[_c('div',{staticClass:"imgCircle",style:({
                width: _vm.widthBgCircle,
                height: _vm.widthBgCircle,
                'min-width': _vm.minWidthBgCircle,
              })},[_c('img',{staticClass:"imgIcon",style:({
                  width: _vm.widthIcon,
                }),attrs:{"src":require("../assets/pengajuan/Computer.svg"),"alt":""}})]),_c('div',{staticClass:"text-point",style:({
                'font-family': 'Inter',
                fontSize: _vm.fontSizeInside,
              })},[_vm._v(" Pinjaman diterbitkan melalui Marketplace Dompet Kilat untuk ditawarkan pada Pendana ")])])]),_c('div',{staticClass:"card-point1",style:({
            marginTop: _vm.marginCard,
          })},[_c('div',{staticClass:"circle-point1",style:({
              width: _vm.widthCircle,
              height: _vm.heightCircle,
            })},[_c('div',{staticClass:"two",style:({
                fontSize: _vm.fontSizeInside,
              })},[_vm._v(" 05 ")])]),_c('div',{staticClass:"point-1",style:({
              width: _vm.widthPointHow,
            })},[_c('div',{staticClass:"imgCircle",style:({
                width: _vm.widthBgCircle,
                height: _vm.widthBgCircle,
                'min-width': _vm.minWidthBgCircle,
              })},[_c('img',{staticClass:"imgIcon",style:({
                  width: _vm.widthIcon,
                }),attrs:{"src":require("../assets/pengajuan/Chart_red.svg"),"alt":""}})]),_c('div',{staticClass:"text-point",style:({
                'font-family': 'Inter',
                fontSize: _vm.fontSizeInside,
              })},[_vm._v(" Pendana menganalisa prospek keuntungan sebelum melakukan pendanaan. ")])])]),_c('div',{staticClass:"card-point1",style:({
            marginTop: _vm.marginCard,
          })},[_c('div',{staticClass:"circle-point1",style:({
              width: _vm.widthCircle,
              height: _vm.heightCircle,
            })},[_c('div',{staticClass:"two",style:({
                fontSize: _vm.fontSizeInside,
              })},[_vm._v(" 06 ")])]),_c('div',{staticClass:"point-1",style:({
              width: _vm.widthPointHow,
            })},[_c('div',{staticClass:"imgCircle",style:({
                width: _vm.widthBgCircle,
                height: _vm.widthBgCircle,
                'min-width': _vm.minWidthBgCircle,
              })},[_c('img',{staticClass:"imgIcon",style:({
                  width: _vm.widthIcon,
                }),attrs:{"src":require("../assets/pengajuan/Money-Bag.svg"),"alt":""}})]),_c('div',{staticClass:"text-point",style:({
                'font-family': 'Inter',
                fontSize: _vm.fontSizeInside,
              })},[_vm._v(" Pencairan pinjaman kepada peminjam untuk menyelesaikan proyek ")])])]),_c('img',{staticClass:"arrow",style:({
            marginLeft: _vm.marginArrowRight,
            marginRight: _vm.marginArrow,
            marginTop: _vm.marginTopArrow,
          }),attrs:{"src":require("../assets/pengajuan/Arrow2.svg"),"alt":""}})])])]),_c('v-row',{staticClass:"phoneContainer",style:({
      height: _vm.heightBgRed,
      flexGrow: 0,
      marginTop: _vm.marginPhone,
      backgroundColor: '#d3352c',
    }),attrs:{"justify":"center"}},[_c('div',{staticClass:"contentPhone fill-height text-wrap",style:({
        marginLeft: '50px',
        marginRight: '50px',
        marginTop: '40px',
        fontSize: _vm.fontSizePhone,
        maxWidth: '750px',
      })},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" Modal Kilat")]),_vm._v(" adalah produk Dompet Kilat yang menyediakan pinjaman untuk memenuhi kebutuhan modal kerja seperti invoice financing dan working capital loan. "),_c('div',[_c('v-btn',{staticClass:"white--text text-none px-12 py-7 mt-3",style:({
            width: _vm.widthBtn,
            height: _vm.heightBtn,
          }),attrs:{"color":"#222222","elevation":"0"},on:{"click":function($event){return _vm.scrollToTop()}}},[_c('div',{staticClass:"contentSandboxButton",style:({
              fontSize: _vm.fontSizeBtn,
            })},[_vm._v(" Ayo Ajukan Sekarang! ")])])],1)]),_c('v-img',{staticStyle:{"margin-top":"-95px","margin-right":"25px"},style:({
        maxWidth: _vm.widthPhone,
      }),attrs:{"contain":"","src":require(`../assets/lpse/phone.webp`)}})],1),_c('popup-success',{attrs:{"dialog":_vm.successPopup,"closeDialog":_vm.closeSuccessDialog}}),_c('popup-error',{attrs:{"dialog":_vm.errorPopup,"errorMessage":_vm.popupMsg,"closeDialog":_vm.closeErrDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }